import { Injectable } from '@angular/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

/**
 * Locally edited fields of *synced* ims/Person records, keyed by the person's
 * ims id.
 *
 * There is no endpoint to write a person to IMS directly - syncbranchpersons
 * only reads. An edit reaches the backend by riding along on the enclosing
 * form: the ProjectContactDirectory entry carries personlabel/personphone/
 * personemail, and the backend's postprocessor updates the person from them
 * on submission.
 *
 * Until that happens the edit only exists in the app, and the synced `persons`
 * table is truncated and refilled on every sync - so an edit written straight
 * into it would be gone with the next one, quite possibly before the form is
 * ever submitted. Holding the changed fields separately lets getPersons()
 * re-apply them on top of the freshly synced row each time.
 *
 * Locally created persons don't need this - they live in `local_persons` and
 * are edited in place.
 */
@Injectable({
  providedIn: 'root',
})
export class LocalPersonOverridesDbTableDefinition extends DbTableDefinition {
  tableName = 'local_person_overrides';
  tableStructure = `(id BIGINT(20) PRIMARY KEY null,
     label TEXT,
     name TEXT,
     lastname TEXT,
     fullname TEXT,
     email TEXT,
     primaryphonenumber TEXT
    );`;

  constructor() {
    super();
    this.updateStatements.set(57, [
      `CREATE TABLE IF NOT EXISTS ${this.tableName}${this.tableStructure}`,
    ]);
  }
}
